/**
 * @author Ariel
 * @description 练习管理页面配置
 * @Date 2023/09/20
 */
import React from 'react';
import { component_tool } from '@/tool';
import moment from 'moment';
import { WizTableForm } from '@/containers/common'
import HighSet from '@/containers/common/highSet';

let { WizModal } = component_tool;

const categoryConfig = WizTableForm.Config.categoryInfo(this, { apiParams: { type: 0, state: 1 } })
const examTempConfig = WizTableForm.Config.examTemp(this, { apiParams: { state: 1 , examTypes:[2] } });

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

let componentName = 'practice';
const columns = () => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '练习名称',
      name: 'name',
      searchItem: {},
      tableItem: {},
    },
    {
      title: '练习状态',
      name: 'status',
      searchItem: { type: 'select' },
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已关闭' }
      ]
    },
    {
      title: '练习时间',
      name: 'practiceDate',
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD'
      }
    },
    {
      title: '考试分类',
      name: 'categoryId',
      searchItem: {
        diy: WizTableForm,
        selectType: 'radio',
        ...categoryConfig
      },
    },
    {
      title: '考试分类',
      name: 'categoryName',
      tableItem: {},
    },
    {
      title: '开始时间',
      name: 'startDate',
      tableItem: {
        render: (text,record) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '结束时间',
      name: 'endDate',
      tableItem: {
        render: (text,record) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '推送时间',
      name: 'pushTime',
      tableItem: {
        render: (text) => {
          if (text) {
            text = text.slice(0,5)
          }
          return text
        }
      }
    },
    {
      title: '练习状态',
      name: 'status',
      tableItem: {},
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已关闭' }
      ]
    },
    {
      title: '创建人',
      name: 'createFullName',
      tableItem: {},
    },
  ]
}

const templateConfig = (data) => {
  const { self } = data;
  let valueRows = []
  let tableFormProps = {
    title: '选择考试模版',
    showModal: false,
    initApiSearch: true,
    showSelectValue: true,
    visible: true,
    selectType: 'radio',
    initRows: [],
    value: [],
    onSubmit: self._addExamByTempSubmit,
    onCancel: self._onCancel,
  }
  const _renderBtn = (value, valueRowList) => {
    if (value && value > 0) {
      value = value[0]
    }
    valueRows = valueRowList
  }
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.practiceDate && value.practiceDate.length === 2) {
              value.startDate = moment(value.practiceDate[0]).format('YYYY-MM-DD')
              value.endDate = moment(value.practiceDate[1]).format('YYYY-MM-DD')
            } else {
              value.startDate = undefined
              value.endDate = undefined
            }
            return value
          },
          buttonSort: ['group', 'export'],
          buttons: [
            {
              type: 'group',
              key: 'group',
              params: {
                key: '_group_btn',
                icon: 'down', children: '新增', type: 'primary',
              },
              options: [
                {
                  key: 'createFromTemplate',
                  custom: true,
                  params: {
                    children: '从考试模版创建'
                  },
                  customOnClick: {
                    key: 'modal',
                    params: {
                      modalParams: {
                        title: '选择考试模版',
                        diy: (e) => {
                          return <WizTableForm key={new Date().getTime()}  {...examTempConfig}  {...tableFormProps} renderValue={_renderBtn} />
                        },
                        onOk: (obj, e) => {
                          self._addExamByTempSubmit({ valueRows: valueRows })
                        },
                        width: 700
                      }
                    }
                  }
                },
                {
                  key: 'add',
                  custom: true,
                  params: { icon: 'plus', children: '新增', type: 'primary' },
                  customOnClick: {
                    key: 'jumpPage',
                    params: {
                      key: 'push',
                      pathname: '/online/practice/add'
                    }
                  }
                }
              ]
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          selectType: 'checkbox',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look', 'update', 'releaseOrClose', 'delete', 'recordManagement', 'rankManagement', 'advancedSet'],
        rowOperateView: [
          {
            key: 'look',
            custom: true,
            params: { children: '查看' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/online/practice/look'
              }
            }
          },
          {
            key: 'update',
            custom: true,
            params: { children: '编辑' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/online/practice/update'
              }
            }
          },
          {
            key: 'releaseOrClose',
            custom: true,
            params: { children: '发布' },
            textFormat: {
              recordKey: 'status',
              dirt: { 0: '发布', 2: '发布', 1: '关闭' }
            },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'enable',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                let newStatus = 1
                if (record && record['status'] && record['status'] === 1) {
                  newStatus = 2
                }
                let content = `您确定要发布该练习吗？`;
                if (newStatus === 2) {
                  content = `您确定要关闭该练习吗？`;
                }
                if (newStatus === 1 && !record['ruleIds']) {
                  WizModal.confirm({
                    title: '注意',
                    content: '该练习还未设计习题，不能发布'
                  })
                } else {
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        id: record['id'],
                        status: newStatus,
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              }
            }
          },
          {
            key: 'delete',
            custom: true,
            params: { children: '删除' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'del'
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '您确定要删除该练习吗？'
                let ids = [];
                if (record) {
                  ids.push(record.id)
                }
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({ids})
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
          },
          {
            key: 'recordManagement',
            custom: true,
            params: { children: '练习记录' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/online/practice/record'
              }
            }
          },
          {
            key: 'rankManagement',
            custom: true,
            params: { children: '练习排行' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/online/practice/rank'
              }
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: { children: '高级设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{ record: e.record, bizType: 59 }}
                        changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            }
          },
        ],
        showAuth: [{
          title: '考试受众',
          dataIndex: 'targetScope',
        }, {
          title: '管理权限',
          text: '查看权限',
          dataIndex: 'managerTargetScope',
        }]
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  del: {
    path: `${componentName}/del`,
    payload: {
      key: `${componentName}@del`,
      apiParams: {}
    }
  },
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
